module.exports = {
  title: "My coding diary", // Required
  author: "Kevin C Jones", // Required
  description: "Frontend Engineer",
  primaryColor: "#3498db", // Required
  showHeaderImage: true,
  showShareButtons: true,
  postsPerPage: 5, // Required
  social: {
    website: "https://www.kevincjones.co.uk",
    github: "https://github.com/kevcjones",
    twitter: "https://twitter.com/kevcjones",
    linkedin: "https://www.linkedin.com/in/kevin-c-jones-7a22372/"
  },
  siteUrl: "https://kevincjones.co.uk"
};
